export default __webpack_public_path__ + "static/media/menu-station-left.e98f2748.png";